import React, {useState, useContext, useEffect} from 'react';
import { IonText, IonGrid, IonRow, IonCol, IonButton, IonModal, IonHeader, IonFooter, IonContent, IonSlides, IonSlide, IonLabel, IonInput, IonImg } from '@ionic/react';
import ReactDOM from 'react-dom';


import { ShowProductPicsModal } from './Modal_ShowProductPics';
import { Auth_MerchantID_context } from '../../../../storeState/auth_merchantID_context';

import { ViewInvoiceModal } from '../../../zInternal_Features/merchant/components/Modal_ViewInvoice';

import { TakePhoto, photos } from '../../../zInternal_Features/merchant/components/TakePhoto';

import '../../../../css/qavaApp.css';


export function Modal_CreateRecipe (props) {


    let authenticatedMerchent_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authenticatedMerchent_context.acctID);
    const [schema, setSchemaName] = useState(authenticatedMerchent_context.schema);
    let [sessionID, setSessionID ] = useState(authenticatedMerchent_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authenticatedMerchent_context.baseURL);

    let [accessRights, setAccessRights ] = useState(authenticatedMerchent_context.accessRights);


    let [selectedFile, setSelectedFile] = useState(null);


    let [productID, setProductID] = useState(null);
    let [productDateCreated, setProductDateCreated] = useState(null);
    let [productPic1, setProductPic1] = useState(null);
    let [productPic2, setProductPic2] = useState(null);

    let [takePhotoStatus1, setTakePhotoStatus1] = useState(false);
    let [takePhotoStatus2, setTakePhotoStatus2] = useState(false);

    let [productPicsModal, setProductPicsModal] = useState(false);

    let [productImageNumber, setProductImageNumber] = useState(null);

    let [ingredientQtyCost, setIngredientQtyCost] = useState("1");
    let [measurementUnit, setMeasurementUnit] = useState("qty");

    let [row_1, setRow_1] = useState(false);
    let [row_2, setRow_2] = useState(false);
    let [row_3, setRow_3] = useState(false);
    let [row_4, setRow_4] = useState(false);
    let [row_5, setRow_5] = useState(false);
    let [row_6, setRow_6] = useState(false);
    let [row_7, setRow_7] = useState(false);
    let [row_8, setRow_8] = useState(false);
    let [row_9, setRow_9] = useState(false);
    let [row_10, setRow_10] = useState(false);
    let [row_11, setRow_11] = useState(false);
    
    let [viewInventoryAvailableProducts, setViewInventoryAvailableProducts] = useState([]);
    
    let [orderID, setOrderID] = useState(null);
    let [orderTotal, setOrderTotal] = useState(null);
    let [invoiceForm, setInvoiceForm] = useState(null);
    let [showInvoiceModal, setViewInvoiceModal] = useState(null);

    let [viewIonPopover, setvViewIonPopover] = useState(false);

    let [itemID, setItemID] = useState(null);
    let [itemID_list, setItemID_list] = useState([]);
    let [createProductType, setCreateProductType] = useState(null);
    let [createProductName, setProductName] = useState(null);
    let [createProductDescription, setCreateProductDescription] = useState(null);
    let [createProductPartNum, setCreateProductPartNum] = useState(null);
    let [createProductPhoneNumber, setCreateProductPhoneNumber] = useState(null);
    let [createProductAddress, setCreateProductAddress] = useState(null);
    let [createProductCity, setCreateProductCity] = useState(null);
    let [createProductCountry, setCreateProductCountry] = useState(null);
    let [createProductCostPerUnit, setCreateProductCostPerUnit] = useState(null);
    let [createProductSalePrice, setCreateProductSalePrice] = useState(null);
    let [createProductQtyInStock, setCreateProductQtyInStock] = useState(0);
    let [createProductQtyInUse, setCreateProductQtyInUse] = useState(null);
    let [createProductDateCreated, setCreateProductDateCreated] = useState(null);
    let [createProductAddedBy, setCreateProductAddedBy] = useState(null); 

    let [ingredientID, setIngredientID] = useState(null);
    let [ingredientName, setIngredientName] = useState(null);
    let [ingredientQtyInStock, setIngredientQtyInStock] = useState(null);
    let [createProductPublicPrice, setCreateProductPublicPrice] = useState(null);

    
    useEffect(() => {

        const requestOptions = {
                method: 'POST',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    Tracker: '74401_retrieveingredient_list',
                    user: acctID,
                    xStartDateRange: authenticatedMerchent_context.startDate,
                    xEndDateRange: authenticatedMerchent_context.endDate,
                    sessionID: sessionID,
                }),
            };
    
            fetch(baseURL + 'hotel_merchantAcct_argsjqApp', requestOptions)
                .then(res => res.text())
                .then(res => {
                    let rows = res.toString().split('~~~');
    
                    for (let rownum = 0; rownum < rows.length - 1; ++rownum) {
                        let cols = rows[rownum].split('|');
    

                        setViewInventoryAvailableProducts((prevAvailableProducts) => {
                            return prevAvailableProducts.concat({
                                ingredientID: cols[0],
                                ingredientName: cols[1],
                                ingredientDescription: cols[2],
                                ingredientPartNum: cols[3],
                                ingredientPhoneNumber: cols[4],
                                ingredientAddress: cols[5],
                                ingredientCity: cols[6],
                                ingredientCountry: cols[7],
                                ingredientCostPerUnit: cols[8],
                                ingredientSalePrice: cols[9],
                                ingredientQtyInStock: cols[10],
                                ingredientMeasurementType: parseFloat(cols[11]).toFixed(2),
                                ingredientDateCreated: parseFloat(cols[12]).toFixed(2),
                                ingredientAddedBy: cols[13],


                            });
                        });
                    }
                });
    }, []);
    

    function selectedFileHandler1(event)
    {

        alert("in Photo");
        alert(event);

        setProductImageNumber("1");
        setProductPic1(event);
        setTakePhotoStatus1(false);
    }

    function selectedFileHandler2(event)
    {
        setProductImageNumber("2");
        setProductPic2(event);
        setTakePhotoStatus2(false);
    }

    function handle_no_attachement(event) {  

        fetch(baseURL+'fileServer/merchants/image-not-available.jpeg')
        .then(res => res.blob())
        .then(data => {

            const blobUrl = URL.createObjectURL(data);

            let noImageFile = new File([data], blobUrl, {
                enctype: 'multipart/form-data',
                type: 'image/jpeg',
                name: 'xImageFile',
                accept: "image/*",
            });
            
            setProductImageNumber(event[0]);
            setProductPic1(noImageFile);
            setProductPic2(noImageFile);

            alert("No Product Pics Option checked");

        })
    }


    function createProduct()
    {
        
        
        //alert("In Crate Product Function");
       //alert(schema);
       //alert(createProductPartNum);
       //alert(createProductPhoneNumber);
       //alert(createProductCostPerUnit);
       // alert(pic4.value);
       //alert(totalProductPics);

        
        let formData = new FormData();
        //formData.append('xProductPics', totalProductPics);
        //formData.append('xProductPics', [ProductPic1, ProductPic2, ProductPic3, ProductPic3]);
        formData.append('Tracker', '74300_createRecipe');
        formData.append('user', acctID);
        formData.append('merchantSchema', schema);
        formData.append('xInventoryItemID_list', JSON.stringify(itemID_list));
        formData.append('xInventoryProductType', createProductType);
        formData.append('xInventoryProductName', createProductName);
        formData.append('xInventoryProductDescription', createProductDescription);
        formData.append('xInventoryProductPartNum', createProductPartNum);
        formData.append('xInventoryProductPhoneNumber', createProductPhoneNumber);
        formData.append('xInventoryProductAddress', createProductAddress);
        formData.append('xInventoryProductCity', createProductCity);
        formData.append('xInventoryProductCountry', createProductCountry);
        formData.append('xInventoryProductCostPerUnit', createProductCostPerUnit);
        formData.append('xInventoryProductSalePrice', createProductSalePrice);
        formData.append('xInventoryProductPublicPrice', createProductPublicPrice);
        formData.append('xProductQtyInStock', createProductQtyInStock);
        formData.append('xSupportingDocumentation', selectedFile);
        //formData.append('xEnterAdminPassword', adminPassword);
        //formData.append('xStorefront', storefront);
        formData.append('sessionID', sessionID);
        formData.append('xPic1', productPic1);
        formData.append('xPic2', productPic2);


        const requestOptions = {
            enctype: 'multipart/form-data',
            method:'POST',
            //credentials: 'include',
            file: formData,
            body: formData,
            contentType: false,
            processData: false,
        }
        


        fetch(baseURL+'hotel_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(data => {

            alert(data);
        })
        .catch(error => {
            console.error(error);
        })

        props.closeModal(false)
    }

    function addItemID_list(event)
    {
        //alert("In Update Address");
        //alert(event)


        const newItem = {
            id: event[1], // Generate a new ID
            name: event[2], // Generate a new ID
            qtyCost: event[3],
            measurmentUnit: event[4], // Random price
          };


        setItemID_list([...itemID_list, newItem]);

        setvViewIonPopover(false);

    }

    function handleFileChange(event) {

        //alert("in HadndleFileChange");
        //alert(event.target.dataset.id);
        // alert(event.target);
        // alert(event.target.files);
        // alert(event.target.files[0]);

        if(event[0] = "1")
        {
            const file = event[1].target.files ? event[1].target.files[0] : null;
            setProductImageNumber(event[1].target.dataset.id);
            setProductPic1(file);
        }
        if(event[0] = "2")
        {
            const file = event[1].target.files ? event[1].target.files[0] : null;
            setProductImageNumber(event[1].target.dataset.id);
            setProductPic2(file);
        }
    }

    function popOverHandler(event)
    {
        //alert("in popoover handler");
        //alert(event);

        setIngredientID(event[1]);
        setIngredientName(event[2]);
        setIngredientQtyInStock(event[3]);

        setvViewIonPopover(true);
    }

    function confirmCheckoutHandler(e)
    {
        e.preventDefault();

        createProduct();

        //confirmGuestBooking(e);
    }

    function handleCreateProductSalePrice(event) {
        const salePrice = parseFloat(event) || 0; // convert to number, default 0
        setCreateProductSalePrice(salePrice);
    
        const productPublicPrice = salePrice + (salePrice * 0.03);
        setCreateProductPublicPrice(productPublicPrice);
    }

    function closeModalHandler(event) {
        setViewInventoryAvailableProducts([]);
        props.closeModal(event);
    }

    function viewInvoiceModalHandler(event) {

        //alert(event);

        setOrderID(event[1]);
        setOrderTotal(event[2]);
        setInvoiceForm(event[3]);
        setViewInvoiceModal(event[0]);

    }
    
    useEffect(() => {

        setSelectedFile("/home/tkweifio/Documents/LocalKuaye/Forms/web/Public/fileServer/merchants/image-not-available.jpg");
        handle_no_attachement();

    }, [])


    return (
        <React.Fragment>
                    
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
            <IonHeader style={{color: 'black'}}>
                <IonGrid>
                    <IonRow>
                        <IonCol>
                            <IonText>CREATE RECIPE</IonText>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonHeader>
             <IonContent className='grid_content'>
                <IonSlides>
                    <IonSlide>
                        <IonContent className='grid_content'>

                        <form onSubmit={confirmCheckoutHandler}>

                        <IonGrid>
                            <IonRow>
                                <IonCol>
                                <IonLabel>Product Name:</IonLabel>
                                </IonCol>
                                <IonCol>
                                {row_2 && (
                                    <IonInput
                                    placeholder="Enter Product Name"
                                    onIonChange={(e) => setProductName(e.detail.value)}
                                    ></IonInput>
                                )}
                                {!row_2 && <IonText>{createProductName}</IonText>}
                                </IonCol>
                                {!row_2 && (
                                <IonCol>
                                    <IonButton onClick={() => setRow_2(true)}>Update</IonButton>
                                </IonCol>
                                )}
                                {row_2 && (
                                <IonCol>
                                    <IonButton onClick={() => setRow_2(false)}>Confirm</IonButton>
                                </IonCol>
                                )}
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                <IonLabel>Product Description:</IonLabel>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                {row_3 && (
                                    <textarea cols="40" rows="10"  placeholder="Enter Product Description" value={itemID_list.map(item => item.name || JSON.stringify(item)).join("\n")} onIonChange={(e) => setCreateProductDescription(e.detail.value)} ></textarea>
                                )}
                                {!row_3 && <textarea cols="40" rows="10" value={itemID_list.map(item => item.name || JSON.stringify(item)).join("\n")} ></textarea>}
                                </IonCol>
                                {!row_3 && (
                                <IonCol>
                                    <IonButton onClick={() => setRow_3(true)}>Update</IonButton>
                                </IonCol>
                                )}
                                {row_3 && (
                                <IonCol>
                                    <IonButton onClick={() => setRow_3(false)}>Confirm</IonButton>
                                </IonCol>
                                )}
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                <IonLabel>Product Cost Per Unit:</IonLabel>
                                </IonCol>
                                <IonCol>
                                {row_9 && (
                                    <IonInput
                                    placeholder="Enter Product Cost Per Unit"
                                    onIonChange={(e) => setCreateProductCostPerUnit(e.detail.value)}
                                    ></IonInput>
                                )}
                                {!row_9 && <IonText>{createProductCostPerUnit}</IonText>}
                                </IonCol>
                                {!row_9 && (
                                <IonCol>
                                    <IonButton onClick={() => setRow_9(true)}>Update</IonButton>
                                </IonCol>
                                )}
                                {row_9 && (
                                <IonCol>
                                    <IonButton onClick={() => setRow_9(false)}>Confirm</IonButton>
                                </IonCol>
                                )}
                            </IonRow>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked" >Merchant Price:</IonLabel>
                                    <IonInput className='professional-input'
                                    value={createProductSalePrice}
                                    type='number' 
                                    step='any'
                                    placeholder="Enter Product Sale Price"
                                    onIonChange={(e) => handleCreateProductSalePrice(e.target.value)}
                                    required
                                    ></IonInput>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol size='12'>
                                    <IonLabel className="form-label" position="stacked" >Product Public Price:</IonLabel>
                                    <IonText className='professional-text'>{createProductPublicPrice}</IonText>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol> 1/4 </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <IonImg src={productPic1}></IonImg>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>                            
                                    <IonButton  onClick={() => setTakePhotoStatus1(true)}> Take Photo</IonButton>
                                    {takePhotoStatus1 == true && <TakePhoto onSelectedFile={selectedFileHandler1}></TakePhoto>}
                                </IonCol>
                                <IonCol>
                                    <input
                                        type="file"
                                        accept="image/jpeg"
                                        data-id='1'
                                        onChange={(e) => handleFileChange(["1", e])}
                                    />
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol> 2/4 </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <IonImg src={productPic1}></IonImg>
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>                            
                                    <IonButton  onClick={() => setTakePhotoStatus2(true)}> Take Photo</IonButton>
                                    {takePhotoStatus1 == true && <TakePhoto onSelectedFile={selectedFileHandler2}></TakePhoto>}
                                </IonCol>
                                <IonCol>
                                    <input
                                        type="file"
                                        accept="image/jpeg"
                                        data-id='2'
                                        onChange={(e) => handleFileChange(["2", e])}
                                    />
                                </IonCol>
                            </IonRow>
                            <IonRow>
                                <IonCol>
                                    <IonButton type='submit' className='grid_checkInFooter_left' > Confirm Purchase </IonButton>
                                </IonCol>
                                <IonCol>
                                    <IonButton onClick={() => closeModalHandler()} className='grid_checkInFooter_right'> Cancel </IonButton>
                                </IonCol>
                            </IonRow>
                        </IonGrid>
                        </form>
                        </IonContent>
                    </IonSlide>
                    <IonSlide>
                        <IonGrid className='appGridContent'>
                                <IonRow>
                                    <IonCol size="12">
                                        <h3> Ingredient List </h3>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='2'>
                                        <h3> Item ID </h3>
                                    </IonCol>
                                    <IonCol size='2'>
                                        <h3> Name </h3>
                                    </IonCol>
                                    <IonCol size='5'>
                                        <h3> QtyInStock </h3>
                                    </IonCol>
                                    <IonCol size='3'>
                                        <h3> Action </h3>
                                    </IonCol>
                                </IonRow>
                                {viewInventoryAvailableProducts.map((detailData) => {
                                    return (
                                        <IonRow key={detailData.ingredientID}>
                                            <IonCol size='2'>{detailData.ingredientID}</IonCol>
                                            <IonCol size='2'>{detailData.ingredientName}</IonCol>
                                            <IonCol size='5'>{detailData.ingredientQtyInStock}</IonCol>
                                            <IonCol size='3'>
                                                <IonButton onClick={() => popOverHandler([true, detailData.ingredientID, detailData.ingredientName, detailData.ingredientQtyInStock])}>Add</IonButton>
                                                <IonButton>Details</IonButton>
                                            </IonCol>
                                        </IonRow>
                                    );
                                })}
                            </IonGrid>

                        
                {viewIonPopover == true && (

                        <div
                        style={{
                        position: 'absolute',
                        width: '75%',
                        height: '50%',
                        backgroundColor: 'white',
                        transform: 'translate(10%, 0%)',
                        padding: '16px',
                        boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                        zIndex: 1000,
                        borderRadius: '8px',       /* Rounded corners */
                        border: '2px rgb(0, 0, 0) solid',
                        }}
                        >

                        <IonGrid>
                                <IonRow >
                                    <IonCol size='6'>Name</IonCol>
                                    <IonCol size='6'>In-Stock</IonCol>
                                </IonRow>
                                <IonRow >
                                    <IonCol size='6'>
                                        <IonText>{ingredientID}</IonText>
                                    </IonCol>
                                    <IonCol size='6'>
                                        <IonText>{ingredientQtyInStock}</IonText>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='6'>
                                        <IonText>Quantity Cost</IonText>
                                    </IonCol>
                                    <IonCol size='6'>
                                        <input type='number' onChange={(e) => setIngredientQtyCost(e.target.value)}></input>
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size='6'>
                                        <IonText>Measurement Unit</IonText>
                                    </IonCol>
                                    <IonCol size='6'>
                                    <select name="paymenttype" id='paymenttype' onChange={(e) => setMeasurementUnit(e.target.value) }>
                                        {/*<option value='cc'>Credit Card</option>*/}
                                        <option value='qty' selected='selected'>Unit</option>
                                        <option value='lb'>Pounds</option>
                                        <option value='ml'>Mililitters</option>*
                                    </select>
                                    </IonCol>
                                </IonRow>

                        </IonGrid>
                        <IonButton className='small_button' onClick={() => addItemID_list([true, ingredientID, ingredientName, ingredientQtyCost, measurementUnit])}>Confirm</IonButton>
                        <IonButton className='small_button' onClick={() => setvViewIonPopover(false)}>close</IonButton>
                        </div>
                        )}   
                    </IonSlide>
                </IonSlides>


            </IonContent>

            <IonFooter class='appFooter'>
                <IonGrid>
                    <IonRow>
                        <IonCol size="12">
                            <IonButton onClick={() => closeModalHandler()}>Cancel </IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
        </IonFooter>
        </IonModal>
        ) : null}
    
        </React.Fragment>

    )
}